import { Component, OnInit } from '@angular/core';

declare var App;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  public footer_logo = App.public_url + 'telemedicine/assets/images/coloredlogo1.svg';

  ngOnInit() {
  }

  goToPage(event){
    if(!App.user_details) {
      window.location.href = App.froent_end_url + event
      // this.router.navigate([App.froent_end_url + event]);
    }
    //console.log(event);
    var newForm = document.createElement('form');
    newForm.setAttribute('id', 'newForm');
    newForm.setAttribute('method', 'post');
    newForm.setAttribute('action', App.froent_end_url + event);

    var hidden_user = document.createElement("input");
    hidden_user.type = "hidden";
    hidden_user.id = "userId";
    hidden_user.name = "userId";
    hidden_user.value = App.user_details.id;

    var hidden_flag = document.createElement("input");
    hidden_flag.type = "hidden";
    hidden_flag.id = "nav_flag";
    hidden_flag.name = "nav_flag";
    hidden_flag.value = "true";

    newForm.appendChild(hidden_user);
    newForm.appendChild(hidden_flag);

    document.body.appendChild(newForm);

    newForm.submit();
  }

}
